import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Clock, XCircle } from 'lucide-react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';

const ProfileReviewStatus = () => {
  const navigate = useNavigate();
  const status = 'under_review'; // This will come from API

  const statusConfig = {
    under_review: {
      icon: Clock,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200',
      title: 'Profile Under Review',
      message: 'Your profile and test results are being reviewed by our admin team. This usually takes 24-48 hours. You will be notified via email once approved.',
    },
    approved: {
      icon: CheckCircle,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      title: 'Profile Approved!',
      message: 'Congratulations! Your profile has been approved and is now live. Students can now find and book sessions with you.',
    },
    rejected: {
      icon: XCircle,
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      title: 'Profile Needs Attention',
      message: 'Unfortunately, your profile could not be approved at this time. Please review the feedback and resubmit.',
    },
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-teal-50 flex items-center justify-center p-4">
      <Card className={`max-w-2xl w-full p-8 ${config.bgColor} border-2 ${config.borderColor}`}>
        <div className="text-center">
          <div className={`w-24 h-24 ${config.bgColor} rounded-full flex items-center justify-center mx-auto mb-6 border-4 ${config.borderColor}`}>
            <Icon className={`h-12 w-12 ${config.color}`} />
          </div>
          <h1 className={`text-3xl font-bold mb-4 ${config.color}`}>{config.title}</h1>
          <p className="text-gray-700 text-lg mb-8">{config.message}</p>
          
          {status === 'under_review' && (
            <div className="bg-white rounded-lg p-6 mb-6 text-left">
              <h3 className="font-semibold text-gray-900 mb-3">What happens next?</h3>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Our team will verify your documents and credentials
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Your test results will be evaluated
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  You'll receive an email notification once approved
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  Your profile will go live immediately after approval
                </li>
              </ul>
            </div>
          )}

          <Button
            onClick={() => navigate('/tutor/dashboard')}
            className="bg-gradient-to-r from-blue-600 to-teal-500 hover:from-blue-700 hover:to-teal-600 text-white"
          >
            Go to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default ProfileReviewStatus;
